var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{staticClass:"organization",attrs:{"title":"组织架构预览","fullscreen":true,"visible":_vm.showDialog},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.close}},[_c('vo-basic',{attrs:{"data":_vm.chartData,"zoom":false,"nodeTitle":_vm.nodeTitle}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d859cefe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/page/Organization.vue
// module id = null
// module chunks = 